<fgb-banner [isHomePage]="true"></fgb-banner>

<fgb-mobile-nav-menu></fgb-mobile-nav-menu>

<div class="d-lg-none">
  <fgb-barcode></fgb-barcode>
</div>

<div class="container mt-lg-30">
  <fgbcl-badge-achieved></fgbcl-badge-achieved>
</div>

<div class="">
  <fgbcl-scorecard-list-view [icon]="'chevron_right'" [showPlaceholder]="true"></fgbcl-scorecard-list-view>
</div>
